import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TestTasksTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function TestTaskTokensSubTab() {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    is_used: '',
    telegram_id: '',
    test_task_id: ''
  });

  useEffect(() => {
    fetchTokens();
  }, []);

  const fetchTokens = async () => {
    try {
      setLoading(true);
      const params = {};
      if (filters.is_used !== '') params.is_used = filters.is_used === 'true';
      if (filters.telegram_id) params.telegram_id = parseInt(filters.telegram_id);
      if (filters.test_task_id) params.test_task_id = parseInt(filters.test_task_id);
      
      const response = await axios.get(`${API_URL}/api/test-task-access-tokens`, { params });
      setTokens(response.data);
      setError(null);
    } catch (err) {
      let errorMsg = 'Ошибка при загрузке токенов';
      if (err.response?.data?.detail) {
        if (typeof err.response.data.detail === 'string') {
          errorMsg = err.response.data.detail;
        } else if (Array.isArray(err.response.data.detail)) {
          errorMsg = err.response.data.detail.map(e => e.msg || JSON.stringify(e)).join('; ');
        } else {
          errorMsg = JSON.stringify(err.response.data.detail);
        }
      } else if (err.message) {
        errorMsg = err.message;
      }
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const handleApplyFilters = () => {
    fetchTokens();
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      alert('Скопировано в буфер обмена');
    }).catch(err => {
      console.error('Ошибка при копировании:', err);
    });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="test-task-tokens-subtab">
      <div className="tab-header">
        <h3>Токены доступа</h3>
        <button onClick={fetchTokens} className="refresh-btn">🔄 Обновить</button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="filters-container">
        <div className="filter-group">
          <label>Статус:</label>
          <select
            value={filters.is_used}
            onChange={(e) => handleFilterChange('is_used', e.target.value)}
          >
            <option value="">Все</option>
            <option value="false">Не использован</option>
            <option value="true">Использован</option>
          </select>
        </div>
        <div className="filter-group">
          <label>Telegram ID:</label>
          <input
            type="number"
            value={filters.telegram_id}
            onChange={(e) => handleFilterChange('telegram_id', e.target.value)}
            placeholder="Все"
          />
        </div>
        <div className="filter-group">
          <label>ID задания:</label>
          <input
            type="number"
            value={filters.test_task_id}
            onChange={(e) => handleFilterChange('test_task_id', e.target.value)}
            placeholder="Все"
          />
        </div>
        <button onClick={handleApplyFilters} className="apply-filters-btn">
          Применить фильтры
        </button>
      </div>

      {tokens.length === 0 ? (
        <div className="info-message">
          <p>Токены не найдены. Токены создаются автоматически при отправке задания пользователю через бота.</p>
        </div>
      ) : (
        <div className="data-table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Токен</th>
                <th>ID задания</th>
                <th>Telegram ID</th>
                <th>Статус</th>
                <th>Создан</th>
                <th>Использован</th>
                <th>Истекает</th>
                <th>URL</th>
              </tr>
            </thead>
            <tbody>
              {tokens.map((token) => (
                <tr key={token.token}>
                  <td>
                    <span className="token-short" title={token.token}>
                      {token.token.substring(0, 10)}...
                    </span>
                    <button
                      onClick={() => copyToClipboard(token.token)}
                      className="copy-btn"
                      title="Копировать полный токен"
                    >
                      📋
                    </button>
                  </td>
                  <td>{token.test_task_id}</td>
                  <td>{token.telegram_id}</td>
                  <td>
                    <span className={token.is_used ? 'status-used' : 'status-active'}>
                      {token.is_used ? '✓ Использован' : '• Активный'}
                    </span>
                  </td>
                  <td>{formatDate(token.created_at)}</td>
                  <td>{formatDate(token.used_at)}</td>
                  <td>{formatDate(token.expires_at)}</td>
                  <td>
                    <button
                      onClick={() => copyToClipboard(token.miniapp_url)}
                      className="copy-btn"
                      title="Копировать URL"
                    >
                      🔗 Копировать
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="info-message" style={{marginTop: '20px'}}>
        <p>
          <strong>Информация о токенах:</strong>
        </p>
        <ul style={{textAlign: 'left', paddingLeft: '20px'}}>
          <li>Каждый токен может быть использован только один раз для открытия страницы задания</li>
          <li>После использования токен помечается как использованный и не может быть использован повторно</li>
          <li>Токены создаются автоматически при отправке задания через бота</li>
        </ul>
      </div>
    </div>
  );
}

export default TestTaskTokensSubTab;
